var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionRequired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.96 0.93 21.07 21.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#337AB7",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.895 1.79 8.977 17.953A1.56 1.56 0 0 1 20.477 22H2.523a1.56 1.56 0 0 1-1.395-2.257L10.105 1.79a1.56 1.56 0 0 1 2.79 0Z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Montserrat-Bold, Montserrat",
    fontSize: 14.556,
    fontWeight: "bold",
    fill: "#FFF",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9.641,
    y: 20.362
  }, "!")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionRequired);
export default __webpack_public_path__ + "static/media/action-required.87804e6f45b2e160cc45a2a094da2f88.svg";
export { ForwardRef as ReactComponent };